import { render } from "./PostArtikulli.vue?vue&type=template&id=1044526a&scoped=true"
import script from "./PostArtikulli.vue?vue&type=script&lang=js"
export * from "./PostArtikulli.vue?vue&type=script&lang=js"

import "./PostArtikulli.vue?vue&type=style&index=0&id=1044526a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1044526a"]])

export default __exports__